import { SVGAttributes, memo } from 'react';

import { Spacings, ThemeColorKeys } from 'types/ui/Theme';

import { SIcon, SIconBadge, SIconWrapper } from './Icon.styled';

import iconsList from './IconsList';

/**
 * Icon
 * @param {String} icon - Icon name
 */

export type IconProps = SVGAttributes<SVGElement> & {
  icon: string;
  // icon: keyof typeof iconsList; TODO -> add correct type (or eliminate this component)
  color?: `${ThemeColorKeys}`;
  badge?: string;
  badgeBackgroundColor?: `${ThemeColorKeys}`;
} & Partial<Spacings>;

const Icon = memo<IconProps>(({ icon, color, badge, badgeBackgroundColor, ...rest }) => {
  if (!badge) {
    /*@ts-expect-error - old component which should be replaced (or these kind of errors gets removed :) )*/
    return <SIcon as={iconsList?.[icon]} color={color} {...rest} height="24px" width="24px" />;
  }

  {
  }
  return (
    <SIconWrapper>
      <SIconBadge $backgroundColor={badgeBackgroundColor}>
        {/*@ts-expect-error - old component which should be replaced (or these kind of errors gets removed :) )*/}
        <SIcon as={iconsList?.[badge]} />
      </SIconBadge>
      {/*@ts-expect-error - old component which should be replaced (or these kind of errors gets removed :) )*/}
      <SIcon as={iconsList?.[icon]} color={color} {...rest} />
    </SIconWrapper>
  );
});

Icon.displayName = 'Icon';

export default Icon;
